import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import PromotionalBanner from '../masterLayout/PromotionalBanner'
import Referral from '../masterLayout/Referral'
const Home = () => {
 const [bannerVisibility, setBannerVisibility] = useState()
 const [referralModal, setReferralModal] = useState()

 // FUNCTION TO CHANGE STATE REFERRAL MODAL
 function closeModal(setValue) {
  setReferralModal(setValue)
 }

 // USEEFFECT LOAD WIDGET PROMOTIONAL BANNER
 useEffect(() => {
  const loadWidgetBanner = async () => {
   try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/widgets`)
    const responseData = await response.json()
    setBannerVisibility(responseData.data[0].promotional_banner)
   } catch (e) {
    console.log(e)
   }
  }
  loadWidgetBanner()
 }, [])

 // USEEFFECT LOAD WIDGET REFERRAL MODAL
 useEffect(() => {
  setTimeout(() => {
   const loadWidgetReferral = async () => {
    try {
     const response = await fetch(`${process.env.REACT_APP_API_URL}/widgets`)
     const responseData = await response.json()
     setReferralModal(responseData.data[0].referral_modal)
    } catch (e) {
     console.log(e)
    }
   }
   loadWidgetReferral()
  }, 5000)
 }, [])

 return (
  <React.Fragment>
   <Helmet>
    <title>Bennabix | Medical Cannabis Savings & Education</title>
    <meta
     name="description"
     content="Bennabix partners with medical cannabis dispensaries and health providers to provide you medical cannabis discounts, cannabis education and more."
    />
   </Helmet>
   {referralModal === 'enable' && <Referral onClick={closeModal} />}
   <div className="homeTemplate">
    {bannerVisibility === 'enable' && <PromotionalBanner />}

    <div className="hone_banner_02">
     <img src={require('../assets/images/home-graphic-02.png')} alt="" />
     <div className="section_wrap">
      <div className="section">
       <span className="text-01">The Power of Medical Cannabis</span>
       <span className="text-02">
        Choose better health{' '}
        <span>with clarity, control, and confidence.</span>{' '}
       </span>
       <span className="action">
        <Link to="/enroll">Find what works</Link>
       </span>
      </div>
     </div>
    </div>

    {/* discountPrograms */}
    <div className="section_wrap">
     <div className="section">
      <div className="discountPrograms">
       <div className="sectionTitle">
        <h1>A Smarter Approach to Wellness. Naturally.</h1>
        <span>
         Successfully use medical cannabis to treat symptoms
         and side effects for a better quality of life.
        </span>
       </div>
       <div className="membershipCard">
        <div className="item">
         <div className="graphic">
          <img
           src={require('../assets/images/membership-type-01.jpg')}
           alt=""
          />
         </div>
         <div className="content">
          <h6>Considering medical cannabis?</h6>
          <p>Find out if it's right for you.</p>
          <Link to="/education/curious">Start Learning</Link>
         </div>
        </div>
        <div className="item">
         <div className="graphic">
          <img
           src={require('../assets/images/membership-type-02.jpg')}
           alt=""
          />
         </div>
         <div className="content">
          <h6>Medical cannabis cardholders</h6>
          <p>Enhance your knowledge.</p>
          <Link to="/enroll">Start Saving</Link>
         </div>
        </div>
       </div>
       <div className="whyUs">
        <h1>A Powerful Addition to the Standard of Care</h1>
        <p>
        Medical cannabis belongs in the modern healthcare conversation.
        It offers another path for patients when conventional treatments fall short or bring unwanted side effects.
        <br /><br />
        Bennabix is committed to helping normalize cannabis in health-care, empowering individuals and institutions to embrace this evolving frontier of medicine. Connecting people to a streamlined experience that saves time and money.
        </p>
       </div>
      </div>
     </div>
    </div>

    {/* statices */}
    <div className="section_wrap staticesWrap">
     <img
      className="banner"
      src={require('../assets/images/cannabis-bg.jpg')}
      alt=""
     />
     <div className="section">
      <div className="item">
       <span>88%</span>
       <strong>US adults feel cannabis should be legal for use by adults.</strong>
      </div>
      <div className="item">
       <span>72+</span>
       <strong>
        Medical cannabis is known to improve many health conditions and side effects.
       </strong>
      </div>
      <div className="item">
       <span>4.5M</span>
       <strong>
        The number of registered medical marijuana card holders in the US.
       </strong>
      </div>
     </div>
    </div>

    {/* quickExplore */}
    <div className="section_wrap">
     <div className="quickExplore">
      <div className="item">
       <div className="card">
        <div className="graphic">
         <img src={require('../assets/images/explore-01.jpg')} alt="" />
        </div>
        <div className="cardInfo">
         <span>Discounts on Medical Cannabis</span>
         <Link to="/network-dispensary">Learn More</Link>
        </div>
       </div>
      </div>
      <div className="item">
       <div className="card">
        <div className="cardInfo">
         <span>Expert Support and Guidance</span>
         <Link to="/members">Learn More</Link>
        </div>
        <div className="graphic">
         <img src={require('../assets/images/explore-02.jpg')} alt="" />
        </div>
       </div>
      </div>
      <div className="item">
       <div className="card">
        <div className="graphic">
         <img src={require('../assets/images/explore-03.jpg')} alt="" />
        </div>
        <div className="cardInfo">
         <span>Medical Cannabis Education </span>
         <Link to="/education/ready">Learn More</Link>
        </div>
       </div>
      </div>
      <div className="item">
       <div className="card">
        <div className="cardInfo">
         <span>Employee Benefits Programs</span>
         <Link to="/work-with-us/health-benefit-plans">Learn More</Link>
        </div>
        <div className="graphic">
         <img src={require('../assets/images/explore-04.jpg')} alt="" />
        </div>
       </div>
      </div>
     </div>
    </div>

    {/* advertisement */}
    <div className="section_wrap cardRegistration">
     <div className="section">
      <div className="advertisement">
       <div className="graphic">
        <img src={require('../assets/images/advertisement.jpg')} alt="" />
       </div>
       <div className="advertisement_info">
        <h4>
         Become a medical cannabis patient.{' '}
         <span>We can help you get started.</span>
        </h4>
        <strong>100% online</strong>
        <div className="handler">
         <Link to="/membership-card">Get Your Card</Link>
        </div>
        <br />
       </div>
      </div>
     </div>
    </div>

    {/* PARTNERSHIPS */}
    <div className="section_wrap collaborative">
     <div className="collaborative_title">Collaborative Partnerships</div>
     <div className="partnerships" style={{ 
       display: 'grid', 
       gridTemplateColumns: 'repeat(2, 1fr)', 
       gap: '2rem',
       maxWidth: '800px',
       margin: '0 auto',
       padding: '2rem'
     }}>
      <span>
       <Link to="/membership-card">
        <img src={require('../assets/images/affiliates/NuggMD.png')} alt="NuggMD" style={{ maxWidth: '80%' }} />
       </Link>
      </span>
      <span>
       <Link to="/membership-card">
        <img src={require('../assets/images/affiliates/ezmedcard.png')} alt="EzMedCard" style={{ maxWidth: '80%' }} />
       </Link>
      </span>
      <span>
       <Link to="/membership-card">
        <img src={require('../assets/images/affiliates/cmed.png')} alt="CMED" style={{ maxWidth: '80%' }} />
       </Link>
      </span>
      <span>
       <a target="_blank" rel="noreferrer" href="https://www.theanswerpage.com/">
        <img src={require('../assets/images/tap-logo.png')} alt="The Answer Page" style={{ maxWidth: '80%' }} />
       </a>
      </span>
      <span>
       <a target="_blank" rel="noreferrer" href="https://leaf411.org/">
        <img src={require('../assets/images/affiliates/leaf411.png')} alt="Leaf411" style={{ maxWidth: '80%' }} />
       </a>
      </span>
      <span>
       <a target="_blank" rel="noreferrer" href="https://2ly.link/24MW7">
        <img src="/tetragram.png" alt="Tetragram" style={{ maxWidth: '80%' }} />
       </a>
      </span>
     </div>
    </div>

    {/* EXPLOREFEATURES */}
    <div className="section_wrap">
     <div className="section">
      <div className="exploreFeatures">
       <Link to="/members">Member Benefits</Link>
       <Link to="/work-with-us/dispensaries">
        Join the <span>Dispensary Network</span>
       </Link>
       <Link to="/work-with-us/medical-providers">
        Education for <span>Medical Providers</span>
       </Link>
      </div>
      <div className="exploreFeatures">
       <Link to="/work-with-us/benefit-professionals">
        Information for <span>Brokers</span>
       </Link>
       <Link to="/work-with-us/health-benefit-plans">
        Options for <span>Health Benefit Plans</span>
       </Link>
       <Link to="/work-with-us/employees-and-dependents">
        Employees & <span>Dependents</span>
       </Link>
       <Link to="/work-with-us/employers">
        Options for <span>Employers</span>
       </Link>
      </div>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}

export default Home
